module.exports = __webpack_public_path__ + "static/media/Patreon3_Support_512.c759e88a.png";